import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import get from 'lodash/get';
import { fetchAppointmentType } from '../store/slices/appointmentTypeSlice';

export const useAppointmentType = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.appointmentType);

  useEffect(() => {
    dispatch(fetchAppointmentType({ limit: 1000 }));
  }, []);

  return {
    items: get(findAll, 'payload.items', [])
  };
};
